<template>
  <div class="order-loading" data-testid="order-loading">
    <HeadingDisplayLoader class="order-loading__header" />
    <ContentDisplayLoader class="order-loading__content">
      <ListDisplayLoader class="order-loading__content__list" />
      <ListDisplayLoader class="order-loading__content__list" />
      <ListDisplayLoader class="order-loading__content__list" />
      <ListDisplayLoader class="order-loading__content__list" />
    </ContentDisplayLoader>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import { ContentDisplayLoader } from '@/modules/trade/components/ContentDisplayLoader';
import { HeadingDisplayLoader } from '@/modules/trade/components/HeadingDisplayLoader';
import { ListDisplayLoader } from '@/modules/trade/components/ListDisplayLoader';

@Component({
  components: {
    ContentDisplayLoader,
    HeadingDisplayLoader,
    ListDisplayLoader
  }
})
export default class OrderLoading extends Vue {}
</script>

<style lang="less" scoped>
.order-loading {
  padding: 0 @size-spacing-x600 @size-spacing-x400 @size-spacing-x600;

  &__header {
    margin-bottom: @size-spacing-x700;
    width: 40%;
  }

  &__content {
    margin-bottom: @size-spacing-x400;

    &__list {
      margin-bottom: @size-spacing-x300;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
